module.exports = {
  name: '小明',
  frame: {
    tel:'电话',
    email: '邮箱',
    hours: '7x24小时为您服务',
    weixin: '微信',
    address: '地址',
  },
  header: {
    home: '首页',
    us: '关于我们',
    product: '产品中心',
    Quality: '质量中心',
    News: '启盈资讯',
    career_opportunities: '工作机会',
    contact_us: '联系我们',

  },
  contactus: {
    title: '联系我们',
    name: '姓名',
    name_msg: '请输入姓名',
    email: '邮箱',
    email_msg: '请输入邮箱',
    tel: '电话',
    tel_msg: '请输入联系电话',
    content: '内容',
    content_msg: '请输入您的留言',
    submit: '提交',

    setEmailMsg: '邮箱不能为空',
    setEmailFormatMsg: '邮箱格式错误',
    setTelErrMsg: '手机号码有误',
    success: '提交成功',
  },
  jobchance: {
    career_opportunities: '工作机会',
    job_responsibilities: '岗位职责',
    job_requirements: '任职要求',
    submit_resume: '投递简历',
  },
  newsinformation : {
    title: '新闻动态',
    qiyngNews: '启盈资讯',
    tradenews: '行业动态'
  },
  quality:{
    quality:'质量中心'
  },
  about:{
    about:'关于我们',
    honor:'荣誉',
    technology:'技术',
  },
  home:{
    ser: '产品服务',
    qy_adv: '我们的优势',
    contact_us:'联系我们',
    get_a_quote:'获取报价'
  },
  sof:{
    ser: '产品',
    all_products:'所有产品',
    main_products :'主要产品',
    product_category: '产品分类',
    all: '全部',
    keyword: '关键字',
    search: '查询',
    inspection_report: '质检报告',

    zh_name:'中文名称',
    en_name:'英文名称',
    plant_source:'植物来源',
    product_specifications:'产品规格',
    molecular_formula:'分子式',
    molecular_weight:'分子量',
  },

  comp:{
    join_us:'加入我们'
  }

}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js